(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1972],{

/***/ 87187:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/hunnys-seasons",
      function () {
        return __webpack_require__(91587);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ hunnys_seasons; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 13 modules
var primitives = __webpack_require__(21666);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
;// CONCATENATED MODULE: ./public/seasonsMonthsGif.gif
/* harmony default export */ var seasonsMonthsGif = ({"src":"/_next/static/media/seasonsMonthsGif.553da7f0.gif","height":675,"width":1200});
;// CONCATENATED MODULE: ./public/seasonsChart.png
/* harmony default export */ var seasonsChart = ({"src":"/_next/static/media/seasonsChart.1d4e51f3.png","height":900,"width":1600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAVFBMVEWzhP+xU8S1jaHn1eno4fXMiJBsGPfJsPKnb+rSv+a+pO3Lu/Xaydve0/PbzOzNl5/y9fW0l6mqibG0f+J7oc1wXUuUpcbAt8R1Uc+tkc6CRqh8X2/XTG+aAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAM0lEQVR4nAXBBwKAIAwAsWO2KIICTv7/TxMAuqqyLiLv/CL75v19BoNLuR7jMhRJwbYn/iNdAbJ1nYvGAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/seasonsGif.gif
/* harmony default export */ var seasonsGif = ({"src":"/_next/static/media/seasonsGif.deb2f3c6.gif","height":750,"width":750});
// EXTERNAL MODULE: ./stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(50530);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(80672);
// EXTERNAL MODULE: ./components/home/Footer.tsx
var Footer = __webpack_require__(53593);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(82731);
// EXTERNAL MODULE: ./components/Card.tsx
var Card = __webpack_require__(16050);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
;// CONCATENATED MODULE: ./pages/about/hunnys-seasons.tsx



















const List = (0,stitches_config/* styled */.zo)("ul", {
    paddingLeft: "1em",
    "& li": {
        position: "relative",
        "&::before": {
            content: '""',
            position: "absolute",
            left: "-1em",
            top: "0.5em",
            width: "0.75em",
            height: "0.75em",
            background: 'url("/hunnysHeart.svg") no-repeat',
            backgroundSize: "contain"
        }
    }
});
const backgroundImage = {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    zIndex: -1,
    backgroundImage: "url('https://hunnys.io/wp-content/uploads/2022/11/Untitled-design-23.png')",
    backgroundRepeat: "repeat",
    backgroundPosition: "center",
    backgroundSize: "tile",
    opacity: 0.05
};
const AboutBlock = (0,stitches_config/* styled */.zo)("div", {
    color: "white",
    border: "3px solid #F4CC45",
    backgroundColor: "#5A1CDA",
    borderRadius: "5px",
    padding: "10px",
    marginBottom: "10px",
    "&:hover": {
        color: "white",
        backgroundColor: "#9362F6"
    },
    "@dark": {
        backgroundColor: "$hunnysDarkPurple"
    }
});
const HunnysPage = (param)=>{
    let { ssr  } = param;
    const isSSR = "object" === "undefined";
    const isMounted = (0,hooks/* useMounted */.s4)();
    const compactToggleNames = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 800px)"
    });
    const [sortByTime, setSortByTime] = (0,react.useState)("1DayVolume");
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const card1Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/cc98e7511c55d337862eb44be7147906.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/9035748af06c090ca87cbed516a9929a.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/5a877a76d5514c036118bf516bb39f7a.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/ce57c064e0db4a79c5957df8c3e8306b.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/bd340aa7398fc13b592d4634e7508241.jpg"
    ];
    const card2Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/95d16f32741034bfc3a50e87ab733643.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/046c0860114f288839d9392c3287237f.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/00a9e4b1156eaece56aecf49a0aae42b.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/b9de241636a93ee014b654aa4bf816c0.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/1a279c912c3b976ccf837b7ef06b814b.jpg"
    ];
    const card3Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/f31cf0715d4b91bb644d8c23ae3d4673.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/bc00242caae6b964d8f9767a8a036e3a.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/c336d4d0a5f13863edf6815da6a55580.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/75ff5200818da3149e78f116400d7c5b.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/874a854de5d67cb42497abf4cfacd65e.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/ef9ccd9f12ee1985a9466d24473778eb.jpg"
    ];
    const card4Images = [
        "https://dl.openseauserdata.com/cache/originImage/files/71d7d82d2266dab0e7e1ccf4813f97cb.png",
        "https://dl.openseauserdata.com/cache/originImage/files/f70891858354912f15971a259fe42a61.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/bfb9239be1109ad11b7cb13d85c5cc28.png",
        "https://dl.openseauserdata.com/cache/originImage/files/e9abaee23be28be6ace0f19240e25bb0.jpg",
        "https://dl.openseauserdata.com/cache/originImage/files/8744b92b25af4f57e171f4084ead1b7d.png"
    ];
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    let volumeKey = "allTime";
    switch(sortByTime){
        case "1DayVolume":
            volumeKey = "1day";
            break;
        case "7DayVolume":
            volumeKey = "7day";
            break;
        case "30DayVolume":
            volumeKey = "30day";
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    background: "#E170BB",
                    p: 24,
                    height: "100%",
                    position: "relative",
                    "@bp800": {
                        p: "$6"
                    },
                    "&::before": backgroundImage
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            mx: "auto",
                            maxWidth: 728,
                            pt: "$5",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "4rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "Hunnys Seasons"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "Hunnys Seasons Gif",
                                src: seasonsGif,
                                width: 200,
                                style: {
                                    borderRadius: 50
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    alignSelf: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        css: {
                                            minWidth: 224,
                                            marginTop: 50,
                                            justifyContent: "center",
                                            fontFamily: "Luckiest Guy, cursive",
                                            background: "#3B66F5",
                                            color: "#FFF",
                                            "&:hover": {
                                                backgroundColor: "#6CCBFA"
                                            },
                                            fontSize: "1.5rem",
                                            fontWeight: 100,
                                            letterSpacing: "1px",
                                            textTransform: "uppercase"
                                        },
                                        size: "large",
                                        children: "Shop Hunnys Seasons"
                                    })
                                })
                            })
                        ]
                    }),
                    isDisconnected && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        align: "center",
                        css: {
                            mx: "auto",
                            maxWidth: 728,
                            pt: "$5",
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body1",
                                css: {
                                    mb: 48
                                },
                                children: "Connect your wallet to begin shopping, or to explore what you already own!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            my: "$6",
                            gap: 65
                        },
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "About"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                css: {
                                    textAlign: "left",
                                    fontSize: 32
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Monthly Rewards for Hunnys 10k & Hunnys OG Holders"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Community-driven character creation & development"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "No staking or claiming needed; airdropped every month"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Dynamic utility available in upcoming hunnys dapps"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Collectible, tradable, fun!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "Monthly Rewards"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "center",
                                align: "center",
                                css: {
                                    flexDirection: "column",
                                    marginRight: "auto",
                                    gap: 12,
                                    "@bp1000": {
                                        alignItems: "center",
                                        flexDirection: "row",
                                        margin: 12
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            width: "calc(50%)",
                                            margin: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            alt: "Hunnys Seasons Gif",
                                            src: seasonsMonthsGif,
                                            style: {
                                                width: "100%",
                                                maxWidth: 720
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            width: "calc(50%)",
                                            margin: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            alt: "Hunnys Seasons Gif",
                                            src: seasonsChart,
                                            style: {
                                                width: "100%",
                                                maxWidth: 720
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "Popular Sets"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "center",
                                align: "stretch",
                                css: {
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    gap: 24,
                                    "@bp1100": {
                                        justifyContent: "space-between"
                                    },
                                    "@bp800": {
                                        justifyContent: "space-between"
                                    },
                                    "@bp500": {
                                        justifyContent: "center"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Rainbow Beaches",
                                        carouselImages: card1Images,
                                        button3Link: "/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BSeason%5D=Rainbow+Mallow+Beaches",
                                        button3Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "30s Cartoon",
                                        carouselImages: card2Images,
                                        button3Link: "/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BSeason%5D=30s+Cartoon",
                                        button3Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Badass Heroines",
                                        carouselImages: card3Images,
                                        button3Link: "/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BSeason%5D=Badass+Heroines",
                                        button3Text: "SHOP"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* Card */.Z, {
                                        headline: "Special",
                                        carouselImages: card4Images,
                                        button3Link: "/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b?attributes%5BRarity%5D=Special",
                                        button3Text: "SHOP"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    fontFamily: "Luckiest Guy, cursive",
                                    fontSize: "3rem",
                                    fontWeight: 100,
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                },
                                children: "More Information"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                                async: true,
                                src: "https://platform.twitter.com/widgets.js",
                                charSet: "utf-8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "center",
                                align: "center",
                                css: {
                                    flexDirection: "column",
                                    marginRight: "auto",
                                    gap: 12,
                                    "@bp1000": {
                                        alignItems: "center",
                                        flexDirection: "row",
                                        margin: 12
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            width: "calc(33%)",
                                            margin: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: '<blockquote class="twitter-tweet"><p lang="en" dir="ltr">✨What is Hunnys Seasons?✨<br><br>Learn more about our monthly rewards for Hunnys Holders (10k &amp; OG collections) below \uD83D\uDC47 <a href="https://t.co/BTbrDgt27z">pic.twitter.com/BTbrDgt27z</a></p>&mdash; Hunnys \uD83D\uDC9B (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1650982870712827904?ref_src=twsrc%5Etfw">April 25, 2023</a>\n                </blockquote>\n              '
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            width: "calc(33%)",
                                            margin: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: '<blockquote class="twitter-tweet"><p lang="en" dir="ltr">\uD83C\uDF89 ANNOUNCEMENT: Hunnys Seasons Holder Rewards! \uD83C\uDF89<br><br>Every Seasons drop is now a magical key, unlocking 1-10 exclusive Hunnys Closet items on Sept 12th! \uD83D\uDDDD️✨<br><br>Been receiving our free airdrops for over a year? It&#39;s reward time, let creativity soar! \uD83C\uDF6F\uD83C\uDF3C <a href="https://twitter.com/hashtag/TheHunnysCloset?src=hash&amp;ref_src=twsrc%5Etfw">#TheHunnysCloset</a> <br><br>/\uD83D\uDC47 <a href="https://t.co/OqlGeElFIJ">pic.twitter.com/OqlGeElFIJ</a></p>&mdash; Hunnys \uD83D\uDC9B | Closet Dropping Sept. 12 (@HunnysNFT) <a href="https://twitter.com/HunnysNFT/status/1698727742068466173?ref_src=twsrc%5Etfw">September 4, 2023</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>\n                </blockquote>\n              '
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    alignSelf: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/collection/polygon/0x43668e306dba9172824524fd2c0c6924e710ea5b",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        css: {
                                            minWidth: 224,
                                            marginTop: 50,
                                            justifyContent: "center",
                                            fontFamily: "Luckiest Guy, cursive",
                                            background: "#3B66F5",
                                            color: "#FFF",
                                            "&:hover": {
                                                backgroundColor: "#6CCBFA"
                                            },
                                            fontSize: "1.5rem",
                                            fontWeight: 100,
                                            letterSpacing: "1px",
                                            textTransform: "uppercase"
                                        },
                                        size: "large",
                                        children: "Shop Hunnys Seasons"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var hunnys_seasons = (HunnysPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,5864,5535,1943,6485,9774,2888,179], function() { return __webpack_exec__(87187); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);